import { commonApi } from '@common/utils/baseQuery';
import config from '@config';
import { NotificationSettings } from '@features/notifications/api/notificationsApi.type';

export const notificationsApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationSettings: builder.query<NotificationSettings, void>({
      query: () => `${config.host}/notifications/settings`,
    }),
    saveNotificationSettings: builder.mutation<NotificationSettings, NotificationSettings>({
      query: (data) => ({
        url: `${config.host}/notifications/settings`,
        body: data,
        method: 'POST',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(notificationsApi.util.updateQueryData('getNotificationSettings', undefined, () => data));
        } catch {
        }
      },
    }),
  }),
});

export const { useGetNotificationSettingsQuery, useSaveNotificationSettingsMutation } = notificationsApi;
